import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import PropTypes from 'prop-types';
import ImageListItem from '@mui/material/ImageListItem';
import { GlobalContext } from '../../../../context/GlobalContext';

function ImageGalleryHorizontal({ parsedimages }) {
  const { apiGlobal } = useContext(GlobalContext);
  const imgPath = `${apiGlobal}/images/meal/attachment/`;

  return (
    <Box
      sx={{
        
        '@media (max-width: 768px)': {
          width: '50%', // 1 column for smaller screens
        },
        '@media (max-width: 1200px)': {
          width: '100%', // 1 column for smaller screens
        },
        maxWidth: 1200,
        height: 450, 
        overflowY: 'scroll', 
        display: 'flex', 
        flexWrap: 'wrap', 
        justifyContent: 'center', // Centers items
      }}
    >
      <ImageList 
        variant="masonry" 
        cols={3} 
        gap={8} 
        rowHeight={164} 
        sx={{
          '@media (max-width: 1200px)': {
            cols: 2, // 2 columns for medium screens
          },
          '@media (max-width: 768px)': {
            cols: 1, // 1 column for smaller screens
          },
        }}
      >
        {parsedimages.map(item => (
          <ImageListItem key={item.img}>
            <img
              src={imgPath + item.file_name}
              alt={item.file_name || 'Gallery image'}
              className="fixed-size-img"
              loading="lazy"
              style={{ borderRadius: '10px' }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}

ImageGalleryHorizontal.propTypes = {
  parsedimages: PropTypes.arrayOf(
    PropTypes.shape({
      logo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      file_name: PropTypes.string.isRequired,
    }),
  ),
};

ImageGalleryHorizontal.defaultProps = {
  parsedimages: [],
};

export default ImageGalleryHorizontal;
